import { Text } from '@shared/components';
import {
  TextField,
  useLoadInitialValues,
} from '@shared/components/react-hook-form';
import { useForm } from 'react-hook-form';

export type PricingFormValues = {
  targetPrice?: string;
  maxPrice?: string;
};

export type PricingFormProps = {
  isLoading: boolean;
  onSubmit: (data: PricingFormValues) => void;
  initialFormData: PricingFormValues;
  recordId: string;
};

// NOTE(parlato): Unset prices must reset to '' rather than undefined; undefined
// leaves the inputs uncontrolled and they keep the previous record's values.
function toFormValues(data: PricingFormValues): Required<PricingFormValues> {
  return {
    targetPrice: data.targetPrice ?? '',
    maxPrice: data.maxPrice ?? '',
  };
}

export function PricingForm(props: PricingFormProps) {
  const formValues = toFormValues(props.initialFormData);
  const { control, reset, getValues } = useForm<PricingFormValues>({
    defaultValues: formValues,
  });
  useLoadInitialValues(reset, formValues, undefined, {
    recordId: props.recordId,
  });

  const onBlur = () => {
    props.onSubmit(getValues());
  };

  return (
    <div className="flex flex-col gap-2 rounded-md border border-gray-200 bg-gray-50 p-2">
      <div className="flex flex-row gap-2">
        <TextField
          onBlur={onBlur}
          label={<Text type="body-sm">Target Price</Text>}
          aria-label="Target Price"
          name="targetPrice"
          control={control}
          type="number"
          size="small"
          inputWrapperClassName="border-r drop-shadow-none"
          fieldWrapperClassName="gap-0"
          prepend={
            <Text type="body-xs" className="pl-[8px] text-gray-500">
              $
            </Text>
          }
        />
        <TextField
          onBlur={onBlur}
          label={<Text type="body-sm">Max Price</Text>}
          aria-label="Max Price"
          name="maxPrice"
          control={control}
          type="number"
          size="small"
          inputWrapperClassName="border-r drop-shadow-none"
          fieldWrapperClassName="gap-0"
          prepend={
            <Text type="body-xs" className="pl-[8px] text-gray-500">
              $
            </Text>
          }
        />
      </div>
    </div>
  );
}
